/*

 MIT License

 Copyright (c) 2022 Looker Data Sciences, Inc.

 Permission is hereby granted, free of charge, to any person obtaining a copy
 of this software and associated documentation files (the "Software"), to deal
 in the Software without restriction, including without limitation the rights
 to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 copies of the Software, and to permit persons to whom the Software is
 furnished to do so, subject to the following conditions:

 The above copyright notice and this permission notice shall be included in all
 copies or substantial portions of the Software.

 THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 SOFTWARE.

 */


/**
 * NOTE: This is an auto-generated file changes within may be overwritten
 * Run `yarn workspace @looker/icons build` to update
 */

import React from 'react'
import type { StyledIcon, StyledIconProps } from '@styled-icons/styled-icon'
import { StyledIconBase } from '@styled-icons/styled-icon'

export const SendWebhook: StyledIcon = React.forwardRef<
  SVGSVGElement,
  StyledIconProps
>((props, ref) => {
  const attrs: React.SVGProps<SVGSVGElement> = {
      "fill": "currentColor",
  "xmlns": "http://www.w3.org/2000/svg",
  }

  return (
    <StyledIconBase
      iconAttrs={attrs}
      iconVerticalAlign="middle"
      iconViewBox="0 0 24 24"
      {...props}
      ref={ref}
    >
      <path d="M10.4482 18.5474C8.96026 20.657 6.05568 21.187 3.95623 19.7194C1.86697 18.2518 1.37778 15.3269 2.84536 13.1969C3.73202 11.9229 5.09768 11.2401 6.49391 11.1789L6.54487 12.6363C5.61745 12.7077 4.72059 13.1867 4.13968 14.0224C3.12053 15.4899 3.43646 17.4671 4.8327 18.4557C6.23913 19.434 8.20609 19.057 9.22524 17.5996C9.54117 17.141 9.72462 16.6416 9.79596 16.132V15.1027L15.4828 15.0619L15.5542 14.9498C16.0943 14.0122 17.2663 13.686 18.1836 14.216C19.1008 14.746 19.4167 15.9282 18.8766 16.8658C18.3364 17.7932 17.1542 18.1193 16.237 17.5894C15.8191 17.355 15.5236 16.9779 15.3911 16.5499L11.2432 16.5702C11.131 17.2531 10.8661 17.9155 10.4482 18.5474ZM17.8676 11.2707C20.4461 11.5866 22.2805 13.9001 21.9646 16.4377C21.6487 18.9856 19.3046 20.7895 16.7262 20.4736C15.2076 20.2901 13.9541 19.4239 13.2305 18.2213L14.4942 17.4875C14.9936 18.2722 15.8395 18.8328 16.8587 18.9652C18.6422 19.1793 20.2219 17.9665 20.4359 16.2645C20.6499 14.5625 19.3862 13.0032 17.623 12.7892C17.0727 12.728 16.5427 12.7994 16.0637 12.9726L15.1975 13.4211L12.568 8.55972H12.3438C11.2635 8.51895 10.4278 7.63229 10.4584 6.57238C10.489 5.51246 11.4062 4.68695 12.4763 4.72772C13.5464 4.78887 14.3923 5.65514 14.3618 6.71506C14.3414 7.16348 14.1681 7.57114 13.8929 7.88708L15.8293 11.4643C16.4612 11.2605 17.1542 11.1891 17.8676 11.2707ZM8.19589 8.49857C7.17674 6.10357 8.25704 3.36206 10.6113 2.36329C12.9757 1.36452 15.707 2.49578 16.7262 4.89078C17.3275 6.28702 17.2052 7.81574 16.5223 9.03872L15.2586 8.30493C15.6866 7.47942 15.758 6.47046 15.3503 5.52265C14.6573 3.89201 12.8126 3.10727 11.233 3.76972C9.64309 4.44235 8.92968 6.31759 9.6227 7.94823C9.90807 8.62087 10.3871 9.14063 10.968 9.48715L11.3654 9.70117L8.23666 14.7867C8.26723 14.8377 8.308 14.8988 8.33858 14.9804C8.83796 15.9078 8.49145 17.0798 7.55383 17.5792C6.6264 18.0786 5.45438 17.7117 4.94481 16.7537C4.44542 15.8059 4.79193 14.6339 5.72955 14.1345C6.12702 13.9204 6.56525 13.8695 6.98311 13.9612L9.33734 10.119C8.85834 9.68078 8.45068 9.13044 8.19589 8.49857Z" />

    </StyledIconBase>
  )
})

SendWebhook.displayName = 'SendWebhook'

export const SendWebhookDimensions = {height: 24, width: 24}
